import React from 'react'
import { Typography } from 'antd'

const ActiveStep = ({ label, position, onChange, controlled, numbers }: { position: number, label: string, onChange: (e: any) => void, controlled: boolean, numbers: boolean }) => {
    return (
        <div className='container-step' onClick={() => {
            console.log(position)
            if (controlled) return
            onChange(position)
        }}>
            {numbers ? <Typography className='position-step'>{position + 1}</Typography> : ''}
            <Typography className='label-step'>{label}</Typography>
        </div>
    )
}

export default ActiveStep
